import useIonicToast from '../../../hooks/useIonicToast';
import { getProductsHashtags } from '../getProductsHashtag';
import { addProductsHashtag } from '../addProductHashtag';

export default function useProductHashTag() {
  const { presentIonToast } = useIonicToast();
  const getAvailableHashTags = async (query: string = '') => {
    try {
      const res = await getProductsHashtags(query);
      return res;
    } catch (error: any) {
      presentIonToast(error.message, 'error');
      throw error;
    }
  };

  const addNewHashtag = async (query: string) => {
    try {
      const res = await addProductsHashtag({ name: query.trim() });
      return res;
    } catch (error: any) {
      presentIonToast(error.message, 'error');
      throw error;
    }
  };

  return { getAvailableHashTags, addNewHashtag };
}
